import { render, staticRenderFns } from "./Rooms.vue?vue&type=template&id=286b2626&scoped=true"
import script from "./Rooms.vue?vue&type=script&lang=ts"
export * from "./Rooms.vue?vue&type=script&lang=ts"
import style0 from "./Rooms.vue?vue&type=style&index=0&id=286b2626&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286b2626",
  null
  
)

export default component.exports